import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../Zonas/ZonasListComponent.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash, faCalendar, faUsers } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AsociadosDeLaLocalidadComponent from './AsociadosDeLaLocalidadComponent'
import Tooltip from '@mui/material/Tooltip';
import { useDispatch } from 'react-redux'
import { eliminarLocalidad } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import SubLocalidadesDeLocalidadComponent from './SubLocalidadesDeLocalidadComponent'
import SublocalidadFormComponent from './SublocalidadFormComponent'
import InstalacionesComponent from './InstalacionesComponent'

library.add(faPen, faTrash, faCalendar, faUsers)

function InstalacionItemComponent(props) {
    const unidad=props.unidad

    return (
        <Fragment>
            <div className={`alert alert-secondary ${estilos.alertItem}`} role="alert" id='index' >
                <div className='row'>
                    <div className='col-md-1 mt-4' style={{ paddingLeft: '7%', position: 'absolute' }}>
                        <div style={{ width: '20px', height: '20px', backgroundColor: unidad.pin, borderRadius: '50%' }}>

                        </div>
                    </div>
                    <div className='col-md-6 mt-3' style={{ paddingLeft: '15%' }}>
                        <h5><strong>{JSON.stringify(unidad.instalacionnombre)}</strong></h5>
                        <p></p>
                    </div>
                    <div className='col-md-4' style={{ fontSize: '30px', textAlign: 'left' }}>

                        <Tooltip title="Editar sublocalidad">
                            <button onClick={()=> alert('hola')} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon icon={faPen} /></button>
                        </Tooltip>
                        <Tooltip title="Borrar sublocalidad">
                            <button onClick={()=>alert('hola')} className={`${estilos.botonItemZona} 
                            ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon icon={faTrash} /></button>
                        </Tooltip>

                        <Tooltip title="Ver Instalaciones">
                            <button onClick={()=>alert('hola')} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`} ><FontAwesomeIcon icon={faUsers} /></button>
                        </Tooltip>

                    </div>
                </div>
            </div>
            <br />
        </Fragment>
    );
};


export default withRouter(InstalacionItemComponent)
